import Bin from "kanopi-components/icons/Bin";
import React, { FC, useCallback, useEffect, useState } from "react";
import Visible from "kanopi-components/icons/Visible";
import { Block } from "kanopi-components/Block";
import { Button } from "kanopi-components/Button";
import { formatBytes } from "kanopi-components/utils/fileSize";
import { getFileType } from "kanopi-components/utils/fileType";
import { StyledLink } from "kanopi-components/Link/StyledLink";
import { TFileWithPath } from "./FileUploader";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import {
  LabelLarge,
  ParagraphMedium,
  ParagraphSmall,
} from "kanopi-components/typography";

type TUploadedFIle = {
  file: TFileWithPath;
  displayMode?: boolean;
  labelColor?: string;
  description?: string;
  deleteFile?: () => void;
};
export const UploadedFile: FC<TUploadedFIle> = ({
  labelColor = "contentInverseSecondary",
  displayMode = false,
  description,
  file,
  deleteFile = () => undefined,
}) => {
  const [displayLabel, setDisplayLabel] = useState<string>();
  const [fileSizeDisplay, setFileSizeDisplay] = useState(undefined);
  const [showIcon, setShowIcon] = useState<boolean>();
  const [, theme] = useStyletron();
  const fileType = getFileType(file?.name) || "";
  useEffect(() => {
    setDisplayLabel(file?.size > 0 ? file?.name : displayLabel);
    setShowIcon(file?.size > 0);
  }, [file?.size, file?.name]);
  useEffect(() => {
    setFileSizeDisplay(formatBytes(file?.size));
  }, []);
  const onDeleteClick = useCallback(() => {
    deleteFile();
  }, []);
  return (
    <Block display="flex" width="100%" justifyContent="space-between">
      <Block display="flex" flexDirection="column">
        {description && <ParagraphMedium margin={0}>{description}</ParagraphMedium>}
        <StyledLink
          href={file?.link}
          download={file?.name}
          target="_blank"
          style={{
            justifyContent: "flex-start",
          }}
        >
          <LabelLarge>{displayLabel}</LabelLarge>
        </StyledLink>
        {(fileType || fileSizeDisplay) && (
          <ParagraphSmall
            color={labelColor}
            margin={0}
            marginTop={theme.sizing.scale100}
          >
            {`${fileType.toLocaleUpperCase()} - `}
            {fileSizeDisplay || ""}
          </ParagraphSmall>
        )}
      </Block>
      {showIcon && (
        <Block>
          {displayMode ? (
            <Visible size={theme.sizing.scale700} />
          ) : (
            <Button
              data-testid={`cta-for-delete-${file?.name?.replace(/\s/g, "")}`}
              onClick={onDeleteClick}
              kind="tertiary"
              shape="circle"
            >
              <Bin size={theme.sizing.scale700} />
            </Button>
          )}
        </Block>
      )}
    </Block>
  );
};
